import React, { useState, useRef, useContext, useEffect, useMemo } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import BlankBG from './assets/BlankBG.png';
import PlayButton from './assets/PlayButton.png';
import LikeIcon from './assets/LikeIcon.png';
import LikeIconActive from './assets/LikeIconActive.png';
import DATBG from './assets/DATBG.png';
import { AppContext } from './AppContext';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { firestore } from './firebase';
import {
  runTransaction,
  doc,
  getDoc
} from 'firebase/firestore';
import { PostScreenShareDAT } from './PostScreenShareDAT';
import { ProfilesDisplayShareDAT } from './ProfilesDisplayShareDAT';
import Modal from 'react-modal';
import { ShareDATPopup } from './ShareDATPopup';

const width = window.innerWidth;
const height = window.innerHeight;
const bottomAreaHeight = 0;
const scrollAreaTopPadding = height * 0.285;

const requireLogin = (userId2, navigate, action) => {
  if (userId2 === 'guest') {
    navigate('/login');
    return false;
  }
  if (typeof action === 'function') action();
  return true;
};


export default function NFTDetail({ initialNFT, onProfilePress, onMoveMP }) {
  const navigate = useNavigate();
  const location   = useLocation();
const { datId, username, slug } = useParams();



  const {
    currentUser,
    setCurrentlyBuying,
    showMediaPopup,
    handlePlayAndClose,
    setIsExpanded,
    setCenteredRelease,
    setArtworkUri,
    assetsSummary,
    setAssetsSummary,
    userWallet,
    setUserWallet,
    userId2, library,
    setSharingReleaseMessage, userAssets, handleLibraryAdd,
    setShareDATactive, setMiniPlayer, playSong, shareDATactive, setShowShareDATPopup, showShareDATPopup,
    isPurchasing, setIsPurchasing, tokensUtility,
    playPlaylistSequentially
  } = useContext(AppContext);

  const useStableImage = (rawUrl, fallback) => {
  const [version, setVersion] = React.useState(0);

  // Reset version whenever the base URL changes
  React.useEffect(() => {
    setVersion(0);
  }, [rawUrl]);

  const src = React.useMemo(() => {
    if (!rawUrl) return fallback;
    const sep = rawUrl.includes('?') ? '&' : '?';
    return `${rawUrl}${sep}cb=${version}`;
  }, [rawUrl, version, fallback]);

  const handleError = (e) => {
    // stop endless loops on bad URLs
    e.currentTarget.onerror = null;
    // bump version once to try again, then stop
    setVersion(v => (v === 0 ? 1 : v));
  };

  return { src, handleError };
};




    const functions = getFunctions();



  const first = initialNFT
    ?? location.state?.nft
    ?? (datId ? assetsSummary?.find(a => a.id === datId) : null);

  const [nft, setNFT] = useState(first);
  const [selectedEdition, setSelectedEdition] = useState(null);
  const [editionDetails, setEditionDetails] = useState({});
  const [nftShouldPlay, setNftShouldPlay] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [holdersModalVisible, setHoldersModalVisible] = useState(false);
  const [isMoreInfoVisible, setIsMoreInfoVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [postSharing, setPostSharing] = useState(false);


// Deep link: when arriving straight to /dat/:datId and nothing is in location.state or assetsSummary,
// fetch the DAT directly so the page isn't blank when not logged in.
useEffect(() => {
  let cancelled = false;
  const run = async () => {
    if (nft || !datId) return; // already have it, or no id present

    setIsLoading(true);
    try {
      // try several places gracefully without assuming auth
      const tryPaths = [
        ['dats', datId],           // if you store DATs here
        ['assets', datId],         // or here
      ];

      // Also consider a summary array doc as a last resort (linear scan)
      const loadFromSummaryArray = async () => {
        const snap = await getDoc(doc(firestore, 'assetsSummary', 'main'));
        const arr = snap.exists() ? (snap.data()?.assets || []) : [];
        return arr.find(a => a.id === datId) || null;
      };

      let found = null;
      for (const [col, id] of tryPaths) {
        try {
          const snap = await getDoc(doc(firestore, col, id));
          if (snap.exists()) { found = { id: snap.id, ...snap.data() }; break; }
        } catch (_) { /* ignore and continue */ }
      }
      if (!found) {
        try { found = await loadFromSummaryArray(); } catch (_) {}
      }

      if (!cancelled && found) setNFT(found);
    } finally {
      if (!cancelled) setIsLoading(false);
    }
  };
  run();
  return () => { cancelled = true; };
}, [nft, datId]);



  /* ——— add-to-library modal ——— */
const [libraryModalVisible, setLibraryModalVisible] = useState(false);


  const baseContentId = nft?.contentId;

  const isPurchasedMedia = 
  currentUser?.purchasedMedia?.some(media => media.contentId === baseContentId) ||
  currentUser?.singles?.some(single => single.contentId === baseContentId) ||
  currentUser?.videos?.some(video => video.contentId === baseContentId) ||
  currentUser?.albums?.some(album => album.contentId === baseContentId) ||
  currentUser?.beats?.some(beat => beat.contentId === baseContentId) ||
  library?.some(item => item.contentId === baseContentId);

const editionsListRef = useRef(null);

const toSlug = (s = '') =>
  String(s).trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

const stripAt = (s = '') => String(s).replace(/^@/, '').toLowerCase();





// when the modal opens, jump to the bottom of the list
useEffect(() => {
  if (isModalVisible && editionsListRef.current) {
    const list = editionsListRef.current;
    list.scrollTop = list.scrollHeight;   // start scrolled to bottom
  }
}, [isModalVisible]);

const toggleLibraryModal = () => {
  const creatorId = nft.userId || nft.creatorId;
  if (userId2 === creatorId) return;
  if (libraryModalVisible) {
    setLibraryModalVisible(false);
  } else {
setLibraryModalVisible(true);
  }
};


const handleLibraryConfirm = () => {

  handleLibraryAdd(nft);
  toggleLibraryModal();
};


  const totalUnsoldRoyalties = useMemo(() => {
    if (!nft?.editions) return 0;
    return nft.editions.filter(ed => ed.isForSale)
      .reduce((sum, ed) => sum + (ed.royalties || 0), 0);
  }, [nft]);

  const genresList = [
    { label: "Alternative", value: "alternative" },
    { label: "Blues", value: "blues" },
    { label: "Classical", value: "classical" },
    { label: "Country", value: "country" },
    { label: "Electronic/Dance", value: "electronic_dance" },
    { label: "Folk", value: "folk" },
    { label: "Rap", value: "hip_hop_rap" },
    { label: "Indie", value: "indie" },
    { label: "Jazz", value: "jazz" },
    { label: "Latin", value: "latin" },
    { label: "Metal", value: "metal" },
    { label: "Pop", value: "pop" },
    { label: "R&B/Soul", value: "rnb_soul" },
    { label: "Reggae", value: "reggae" },
    { label: "Rock", value: "rock" },
    { label: "World/International", value: "world_international" }
  ];

  // ADD: normalize credits into 2-column rows like RN
const creditRows = useMemo(() => {
  if (!nft) return [];

  const asDisplay = (item) => {
    if (typeof item === 'string') return { text: item, id: null };
    const isTagged = item?.id && !/^\d+$/.test(item.id);
    const text = isTagged
      ? (item.tag?.startsWith('@') ? item.tag : '@' + item.tag)
      : (item?.tag ?? '');
    return { text, id: isTagged ? item.id : null };
  };

  const labelForGenre = (g) =>
    (genresList.find(x => x.value === g) || {}).label || g;

  const blocks = [];
  if (nft?.producers?.length)
    blocks.push({ title: 'Producers',    items: nft.producers.map(asDisplay) });
  if (nft?.songwriters?.length)
    blocks.push({ title: 'Songwriters',  items: nft.songwriters.map(asDisplay) });
  if (nft?.recordLabels?.length)
    blocks.push({ title: 'Record Labels', items: nft.recordLabels.map(asDisplay) });
  if (nft?.genres?.length)
    blocks.push({ title: 'Genres', items: nft.genres.map(g => ({ text: labelForGenre(g), id: null })) });

  const rows = [];
  for (let i = 0; i < blocks.length; i += 2) {
    rows.push([blocks[i], blocks[i + 1] || null]);
  }
  return rows;
}, [nft, genresList]);


  // Retry logic for play
  useEffect(() => {
    let retries = 0;
    const maxRetries = 5;
    const checkCenteredRelease = () => {
      if (nftShouldPlay && retries < maxRetries) {
        retries++;
        setTimeout(checkCenteredRelease, 1000);
      } else if (nftShouldPlay) {
        handlePlayAndClose(false);
        setNftShouldPlay(false);
      }
    };
    if (nftShouldPlay) checkCenteredRelease();
  }, [nftShouldPlay, handlePlayAndClose]);

  // Sync NFT from route and summary
useEffect(() => {
  if (!initialNFT?.contentId) return;
  const match = assetsSummary?.find(a => a.contentId === initialNFT.contentId);
  if (!match) return;
  // Only set when something material changes
  if (nft?.contentId !== match.contentId) {
    setNFT(match);
  }
}, [assetsSummary, initialNFT?.contentId, nft?.contentId]);


  // Update likeCount dynamically
useEffect(() => {
  const upd = assetsSummary?.find(a => a.id === nft?.id);
  if (upd && upd.likeCount !== nft?.likeCount) {
    setNFT(p => ({ ...p, likeCount: upd.likeCount }));
  }
}, [assetsSummary, nft?.id, nft?.likeCount]);

const [artSrc, setArtSrc] = useState(BlankBG);
useEffect(() => {
  let alive = true;
  const url = nft?.ArtworkURL;
  if (!url) return setArtSrc(BlankBG);
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = () => { if (alive) setArtSrc(url); };
  img.onerror = () => { if (alive) setArtSrc(BlankBG); };
  img.src = url;
  return () => { alive = false; };
}, [nft?.ArtworkURL]);


  // Select default edition
  useEffect(() => {
    if (!selectedEdition && nft?.editions?.length) {
      const last = nft.editions.filter(e => e.isForSale).pop() || nft.editions[0];
      setSelectedEdition(last.edition);
      setEditionDetails(last);
    }
  }, [nft, selectedEdition]);

  // Helper: fetch user doc
  async function getUserDoc(userId) {
    const snap = await getDoc(doc(firestore, 'users', userId));
    return snap.exists() ? snap.data() : null;
  }

  // Open popup with user profile
  async function handleUserPopup(nftItem, autoplay = false) {
    const userData = await getUserDoc(nftItem.userId);
    if (!userData) return;
    const item = assetsSummary.find(a => a.contentId === nftItem.contentId) || nftItem;
    const popupData = {
      ...userData,
      ...item,
      shouldPlay: autoplay,
      url: nftItem.SongURL,
      artworkUrl: nftItem.ArtworkURL,
      isNFT: true
    };
    if (autoplay) setNftShouldPlay(true);
    showMediaPopup(popupData);
    setCenteredRelease(nftItem);
  }


  const handleSPNDATButtonClick = async (nft, userId2, skipStreamContent = false) => {
  
  if (userId2 === 'guest') {
    navigate('/login');
    return;
  }


    if (tokensUtility < 0.10 && !isPurchasedMedia) {
           alert("Click the Add button in the top right to add Utility Tokens to SPN this DAT");
return;
    }



if (nft?.isAlbum) {
      
      
      playPlaylistSequentially(nft?.songs);
      
      setMiniPlayer(nft?.songs[0]);
} else {

      setMiniPlayer(nft);
      playSong(nft.SongURL);

}
  
    // Get the current date and time
    const now = new Date();
    const isVideo = false;
    const timestamp = now.getTime();
    const contentId = nft.contentId;
    const userId = userId2;
    const streamSongName = nft.SongName;
    const readableTimestamp = now.toLocaleString('en-US', {
      hour12: true,
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });

    const isOwned = userAssets?.some(asset => asset.id === nft?.id);
    if (isOwned) {

      return;
    }
      if (!isPurchasedMedia) {
    const streamContentIOSEdition = httpsCallable(functions, 'streamContentIOSEditionDatChain');
    const result = await streamContentIOSEdition({
      contentId,
      userId,
      isVideo,
      streamSongName,
      readableTimestamp,
      timestamp
  });
}
  
    try {
      // Log the data before calling the cloud function to ensure all fields are correct
      if (skipStreamContent) {
        
      } else {

        
      }
    } catch (error) {
      console.error('Error calling cloud function:', error);
    }
  };

  // Handlers
  const handlePressBegins = nftItem => handleUserPopup(nftItem, false);
  const handlePressBegins2 = nftItem => handleUserPopup(nftItem, true);
  const toggleModal = () => setIsModalVisible(v => !v);



  const toggleHoldersModal = () => setHoldersModalVisible(v => !v);
  const toggleMoreInfo = () => setIsMoreInfoVisible(v => !v);

  const generateDeepLink = () => {
    const base = 'https://spndat.com/dats';
    const user = nft.creatorUsername.replace('@','');
    return `${base}/${user}/${nft.SongName.trim().replace(/\s+/g,'-')}?source=app`;
  };
  const copyToClipboard = txt => {
    navigator.clipboard.writeText(txt);
    alert('Link copied to clipboard!');
  };
  const shareDeepLink = async () => {
    const link = generateDeepLink();
    copyToClipboard(link);
    try { await navigator.share({ text: `Check this out on SPNDAT: ${link}` }); }
    catch {}
  };

  const handleOptionSelect = (opt) => {
    toggleMoreInfo();
    if (opt === 'Share to Feed') setPostSharing(true);
    else if (opt === 'Copy Link') shareDeepLink();
    else if (opt === 'Send in Message') setShareDATactive(true);
  };

  const handleLikePress = async assetId => {
    const summaryRef = doc(firestore, 'assetsSummary', 'main');
    const userWalletRef = doc(firestore, 'users', userId2, 'wallet', 'main');
    let likes = userWallet?.likes || [];
    const already = likes.includes(assetId);
    // optimistic UI
    setNFT(n => n.id === assetId
      ? { ...n, likeCount: already ? n.likeCount - 1 : n.likeCount + 1 }
      : n
    );
    setUserWallet(u => ({
      ...u,
      likes: already
        ? u.likes.filter(id => id !== assetId)
        : [...u.likes, assetId]
    }));
    await runTransaction(firestore, async tx => {
      const sd = await tx.get(summaryRef);
      const arr = sd.data().assets || [];
      const idx = arr.findIndex(a => a.id === assetId);
      if (idx < 0) throw new Error();
      const a = arr[idx];
      a.likeCount = already ? a.likeCount - 1 : a.likeCount + 1;
      likes = already ? likes.filter(id => id !== assetId) : [...likes, assetId];
      arr[idx] = a;
      tx.update(summaryRef, { assets: arr });
      tx.set(userWalletRef, { likes }, { merge: true });
      setAssetsSummary(arr);
    });
  };

  const handleBuyNow = async () => {
    setCurrentlyBuying(true);
    try {
      const fn = getFunctions();
      const txProc = httpsCallable(fn, 'transactionProcessor2');
      const res = await txProc({
        buyer: userId2,
        seller: editionDetails.currentOwnerId,
        datId: nft.id,
        edition: selectedEdition,
        timestamp: Date.now()
      });
      alert(`Transaction successful! ${JSON.stringify(res.data)}`);
    } catch (e) {
      alert(`Transaction failed: ${e.message}`);
    } finally {
      setCurrentlyBuying(false);
    }
  };

const handlePressProfile = (profile) => {
  const clonedProfile = JSON.parse(JSON.stringify(profile));
  const targetRoute = profile.userId === userId2 ? '/mydat/profile' : `/userprofile/${profile.username}`;
  navigate(targetRoute, { state: { profile: clonedProfile, fromURL: false } });
};



const fetchUserProfile = async (userId) => {
  try {
    const userDocRef = doc(firestore, 'users', userId);
    const userDoc = await getDoc(userDocRef);
    if (userDoc.exists()) {
      handlePressProfile(userDoc.data());
    } else {
      
    }
  } catch (error) {
    console.error('Error fetching user profile:', error);
  }
};

const fetchUserProfileByUserId = async (userId) => {
  if (!userId) {
    
    return;
  }

  try {
    fetchUserProfile(userId);

  } catch (error) {
    console.error('fetchUserProfileByUserId: Error fetching user by userId:', error);
  } finally {

    setIsLoading(false);
  }
};

useEffect(() => {
  const styleEl = document.createElement('style');
  styleEl.innerHTML = `
    @keyframes softPulse {
      0%   { transform: scale(0.97); }
      50%  { transform: scale(1); }
      100% { transform: scale(0.97); }
    }
  `;
  document.head.appendChild(styleEl);
  return () => document.head.removeChild(styleEl);
}, []);

// helper that renders (and optionally navigates from) each edition row
const renderEditionItem = (item) => {
  // the edition row should only be clickable if it’s for sale
  // **and** the viewer isn’t the creator
  const creatorId   = nft.userId || nft.creatorId;
  const isCreator   = userId2 === creatorId;
  const isClickable = item.isForSale && !isCreator;

  return (
    <div
      key={item.edition}
      style={{
        ...styles.editionItem,
        cursor : isClickable ? 'pointer' : 'default',
        opacity: item.isForSale ? 1 : 0.4          // dim SOLD / creator-owned rows
      }}
onClick={() => {
  if (!isClickable) return;
  // require login before taking user to purchase flow
  const go = () => {
    toggleModal();
    navigate('/wallet', {
      state: {
        purchaseDetails: {
          nft,
          editionDetails: item,
          selectedEdition: item.edition,
        },
      },
    });
  };
  requireLogin(userId2, navigate, go);
}}

    >
      <span style={styles.bulletPoint}>●</span>

      <div style={styles.editionRow}>
        <span style={styles.editionLeftText}>
          Edition&nbsp;#{item.edition}
        </span>

        <span
          style={{
            ...styles.priceText,
            color: item.isForSale ? '#37FF8B' : '#FF4949',
          }}
        >
          ${item.price.toLocaleString()}
        </span>

        <span
          style={{
            ...styles.editionRightText,
            color: item.isForSale ? '#fff' : '#FF4949',
          }}
        >
          {item.isForSale ? `${(item.royalties ?? 0).toFixed(4)}%` : 'SOLD'}
        </span>
      </div>
    </div>
  );
};

  

  const renderHolder = h => (
    <div key={h.edition} style={styles.holderRow}>
      <div style={styles.holderInfo}
           onClick={() => { toggleHoldersModal(); /* fetch profile if needed */ }}>
        <img src={h.profileImageUrl} style={styles.creatorImage} alt="" />
        <span style={styles.creatorUsername}>{h.username}</span>
      </div>
      <span style={styles.holderEditionText}>#{h.edition}</span>
    </div>
  );

  // Render guard while we fetch or resolve the DAT for deep links
if (!nft) {
  return (
    <div style={styles.fullScreen}>
      <img src={BlankBG} style={styles.fullScreenImage} alt="" />
      <div style={{ zIndex: 1, padding: 16, color: '#fff', fontFamily: 'brhendrix' }}>
        Loading DAT…
      </div>
    </div>
  );
}


  return (
    <div style={styles.fullScreen}>
      <img src={BlankBG} style={styles.fullScreenImage} alt="" />
      <div style={styles.scrollContainer}>

        {/* Artwork */}
        <div style={styles.artworkContainer} onClick={() => requireLogin(userId2, navigate, () => handleSPNDATButtonClick(nft))}>
          <div style={{
     ...styles.nftImage,
     animation: 'softPulse 1s ease-out infinite',
   }}>
  <img
    src={artSrc}
    alt=""
    style={styles.nftImage}
    crossOrigin="anonymous"
  />



            <img src={PlayButton} style={styles.playIcon} alt="" />
          </div>
        </div>

        {/* Like & Title */}
        <div style={styles.likeButtonRow}>
         <button
  style={styles.iconButtonLike}
  onClick={() => requireLogin(userId2, navigate, () => handleLikePress(nft?.id))}
>

            <img
              src={userWallet?.likes?.includes(nft?.id) ? LikeIconActive : LikeIcon}
              style={styles.iconImage}
              alt=""
            />
            <span style={styles.likeCount}>{nft?.likeCount || 0}</span>
          </button>
          <div style={styles.titleContainer}>
            <p style={styles.spndatText}>
              {nft.ArtistName} – {nft.SongName}
            </p>
          </div>
        <button
  style={styles.ellipsisButton}
  onClick={() => requireLogin(userId2, navigate, toggleMoreInfo)}
>
  ⋮
</button>

        </div>

        {/* Actions */}
        <div style={styles.buttonRow}>
          <button style={styles.buyNowButton} onClick={toggleModal}>BUYDAT</button>
          <button style={styles.buyNowButton} onClick={() => requireLogin(userId2, navigate, toggleLibraryModal)}>+LIBRARY</button>
          <button style={styles.buyNowButton} onClick={toggleHoldersModal}>
            Holders
          </button>
        </div>

        {/* Edition Modal */}
        {isModalVisible && (
  <div style={styles.modalOverlay}>
    <div style={styles.modalContent}>            {/* flex column */}
      <div
        style={styles.editionsList}              /* scrollable area */
        ref={editionsListRef}
      >
        {nft.editions.map(renderEditionItem)}
      </div>

      {/* pinned button – never scrolls off-screen */}
      <button style={styles.closeModalButton} onClick={toggleModal}>
        Close
      </button>
    </div>
  </div>
)}


        {/* More Info Modal */}
        {isMoreInfoVisible && (
          <div style={styles.modalOverlayInfo} onClick={toggleMoreInfo}>
            <div style={styles.modalOptionsContainerInfo} onClick={e => e.stopPropagation()}>
              {['Share to Feed', 'Copy Link', 'Send in Message'].map(opt => (
                <button key={opt} style={styles.optionButtonInfo} onClick={() => handleOptionSelect(opt)}>
                  <span style={styles.optionTextInfo}>{opt}</span>
                </button>
              ))}
              <button style={styles.closeButtonInfo} onClick={toggleMoreInfo}>
                <span style={styles.closeButtonTextInfo}>Close</span>
              </button>
            </div>
          </div>
        )}

        {/* Fullscreen Artwork */}
        {modalVisible && (
          <div style={styles.fullScreenContainer} onClick={() => setModalVisible(false)}>
    <img
      src={currentImage || nft?.ArtworkURL || BlankBG}
      onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = BlankBG; }}
      style={{ width, height, objectFit: 'contain' }}
      alt=""
      crossOrigin="anonymous"
      loading="eager"
      decoding="async"
    />



          </div>
        )}

        {/* Holders Modal */}
        {holdersModalVisible && (
  <div style={styles.modalOverlay2}>
    <div style={styles.modalContent2}>

      {/* scrollable list */}
      <div style={styles.holdersList}>
        {nft.editions.filter(ed => ed.currentOwnerId !== nft.userId).length === 0 ? (
          <div>
            <span style={styles.emptyText2}>
              There are no current holders
            </span>
          </div>
        ) : (
          nft.editions
            .filter(ed => ed.currentOwnerId !== nft.userId)
            .map(h => (
              <div key={h.edition} style={styles.holderRow2}>
                <div
                  style={styles.holderInfo2}
                  onClick={() => {
                    fetchUserProfileByUserId(h.currentOwnerId);
                    /* fetch profile if needed */
                  }}
                >
<img
  src={h.profileImageUrl || BlankBG}
  onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = BlankBG; }}
  style={styles.creatorImage}
  alt=""
  loading="eager"
  referrerPolicy="no-referrer"
  crossOrigin="anonymous"
/>




                  <span style={styles.creatorUsername2}>
                    {h.username}
                  </span>
                </div>
                <span style={styles.holderEditionText2}>
                  #{h.edition}
                </span>
              </div>
            ))
        )}
      </div>

      {/* pinned close button */}
      <button
        style={styles.closeModalButton2}
        onClick={toggleHoldersModal}
      >
        Close
      </button>
    </div>
  </div>
)}



        {/* Post Sharing */}
        {postSharing && (
          <div style={styles.PostScreenShareDAT}>
            <PostScreenShareDAT centeredRelease={nft} onNavigate={() => navigate('/social')} />
            <button onClick={() => setPostSharing(false)} style={styles.closeButtonPost}>
              <span style={styles.closeButtonTextPost}>Close</span>
            </button>
          </div>
        )}

        {/* Creator Section */}
        <div style={styles.creatorSection}>
          <div style={styles.creatorContainer} onClick={() => fetchUserProfileByUserId(nft.userId)}>
            <img src={nft.profileImageUrl} style={styles.creatorImage} alt="" />
            <span style={styles.creatorUsername}>{nft.creatorUsername}</span>
          </div>
        </div>

        {/* Details */}
        <div style={styles.details}>
          <p style={styles.detailItem}>
            Tier: {nft.tier?.[0].toUpperCase() + nft.tier?.slice(1) || 'N/A'}
          </p>
          <p style={styles.detailItem}>Chain: {nft.chain}.com</p>
          <p style={styles.detailItem}>Total Streams:</p>
          <p style={styles.detailItem}>
  Available for Ownership: {parseFloat(totalUnsoldRoyalties.toFixed(4))}%
</p>
        </div>

        {/* Song Credits */}
{/* Song Credits (aligned with RN) */}
<div style={styles.songCreditsSection}>
  <div style={styles.creditGrid}>
    {creditRows.map((pair, rowIdx) => (
      <div key={`row-${rowIdx}`} style={styles.creditRow}>
        {pair.map((block, colIdx) => (
          <div key={`col-${rowIdx}-${colIdx}`} style={styles.creditCard}>
            {block ? (
              <div style={styles.creditCardInner}>
                <p style={styles.creditCategoryTitleCentered}>{block.title}</p>
                <div style={styles.creditList}>
                  {block.items.map((item, i) => {
                    const isLink = !!item.id;
return (
  <div key={`${block.title}-${i}`} style={styles.creditTextRow}>
    {isLink ? (
      <a
        href="#"
        onClick={(e) => { e.preventDefault(); fetchUserProfileByUserId(item.id); }}
        style={{ ...styles.creditTextCentered, ...styles.creditLink, ...styles.ellipsisBlock }}
        title={item.text}
      >
        {item.text}
      </a>
    ) : (
      <p
        style={{ ...styles.creditTextCentered, ...styles.ellipsisBlock }}
        title={item.text}
      >
        {item.text}
      </p>
    )} 
  </div>
);

                  })}
                </div>
              </div>
            ) : (
              // empty placeholder keeps the row symmetrical
              <div style={{ ...styles.creditCardInner, ...styles.creditCardPlaceholder }} />
            )}
          </div>
        ))}
      </div>
    ))}
  </div>
</div>

      </div>

      <Modal
      isOpen={shareDATactive}
      onRequestClose={() => setShareDATactive(false)}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          zIndex: 10000,
          overflow: 'hidden' 
        },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          height: '630px',
          display: 'flex',
          width: '480px',
          flexDirection: 'column',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'transparent',
          padding: '20px',
          border: 'none',
          borderRadius: '8px',
          overflow: 'hidden' 
        },
      }}
    >
      <div style={styles.sharingMessage}>

      <ProfilesDisplayShareDAT/>
      </div>

      <div style={styles.closeWrapper}>
    <button style={styles.closeButtonMessage} onClick={() => setShareDATactive(false)}>
      <span style={styles.closeButtonTextMessage}>Close</span>
    </button>
  </div>
    </Modal>

    <Modal
      isOpen={showShareDATPopup}
      onRequestClose={() => setShowShareDATPopup(false)}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          zIndex: 10000,
        },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          height: '400px',
          width: '90%',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'transparent',
          padding: '20px',
          border: 'none',
          borderRadius: '8px',
        },
      }}
    >
      <div style={styles.sharingPost}>
      <ShareDATPopup
      centeredRelease={nft}
      />
      </div>
    </Modal>

    <Modal
  isOpen={libraryModalVisible}
  onRequestClose={toggleLibraryModal}
  style={{
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      zIndex: 10000,
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      width: '90%',
      maxWidth: '400px',
      transform: 'translate(-50%, -50%)',
      backgroundColor: '#120F23',
      padding: '24px',
      border: 'none',
      borderRadius: '8px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  }}
>
  <h2 style={styles.modalTitle}>Confirm Purchase</h2>

  {userAssets?.some(a => a.contentId === nft.contentId) ||
   library?.some(a => a.contentId === nft.contentId) ? (
    <>
      <p style={styles.modalText}>This song is already in your library.</p>
      <div style={styles.modalButtons}>
        <button style={styles.modalButton} onClick={toggleLibraryModal}>
          <span style={styles.modalButtonText}>Close</span>
        </button>
      </div>
    </>
  ) : (
    <>
      <p style={styles.modalText}>
        Would you like to add this {nft.isAlbum ? 'album' : 'song'} to your Library for&nbsp;
        ${nft.isAlbum ? '20' : '10'}?&nbsp;
        
      </p>
      <div style={styles.modalButtons}>
        <button style={styles.modalButton} onClick={toggleLibraryModal}>
          <span style={styles.modalButtonText}>Cancel</span>
        </button>
        <button style={styles.modalButton} onClick={handleLibraryConfirm}>
          <span style={styles.modalButtonText}>Yes</span>
        </button>
      </div>
    </>
  )}
</Modal>

    <Modal
  isOpen={isPurchasing}
  style={{
    overlay: {
      backgroundColor: 'rgba(17, 14, 14, 0.75)',
      zIndex: 1000000
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      border: 'none',
      background: 'transparent',
      color: 'white',
      borderRadius: '10px',
      padding: '20px',
      textAlign: 'center',
      zIndex: 1000000,
    }
  }}
>
  <h2>Purchasing Content...</h2>
</Modal>


      <img src={DATBG} style={styles.popupImage} alt="" />
    </div>
  );
}

const styles = {
  /* ───── layout & background ───── */
  fullScreen: {
    position: 'relative',
    width:  '100%',
    maxWidth: '480px',               // center-column like iOS build
    height: '100vh',
    margin: '0 auto',
    background: '#0e061e',
    borderLeft:  '2px solid #62fbfa',
    borderRight: '2px solid #62fbfa',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  fullScreenImage: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: 0,
    pointerEvents: 'none',
  },

  /* ───── scroll area ───── */
  scrollContainer: {
    flex: 1,
    overflowY: 'auto',
    overscrollBehavior: 'contain',
    paddingTop: 16,
    paddingBottom: height * 0.38,     // room for bottom fades / mini-player
    zIndex: 1,
  },

  /* ───── artwork ───── */
  artworkContainer: {
    width: '100%',
    aspectRatio: '1/1',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  nftImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: 10,
  },
  playIcon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    width:  width * 0.068,
    height: width * 0.08,
    pointerEvents: 'none',
    zIndex: 2,
  },

  /* ───── like + title + ellipsis ───── */
  likeButtonRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1px 16px',
  },
  iconButtonLike: {
    background: 'transparent',
    border: 0,
    cursor: 'pointer',
    padding: 0,
    display: 'flex',
    alignItems: 'center',  // this is what you want!
    gap: '6px',
    height: '32px',
  },
  
  
  
  likeButtonContainer: { display: 'flex', alignItems: 'center', gap: 6 },
  iconImage: {
    width: '20px',
    height: '20px',
    objectFit: 'contain',
    margin: 0,
    verticalAlign: 'middle',   // <-- this helps!
    display: 'inline-block',   // <-- important for verticalAlign to work
  },
  
  
  
  likeCount: {
    color:'#fff',
    fontFamily:'brhendrix',
    fontSize: '16px',
    fontWeight: 500,
    marginTop: '5px'
    // no verticalAlign!
  },
  

  titleContainer: { flex: 1, padding: '0 12px', display: 'flex', justifyContent: 'center' },
  spndatText: {
    color:'#fff',
    fontFamily:'brhendrix',
    fontSize: 17,
    lineHeight: '21px',
    textAlign: 'center',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,              // max 2 lines
  },
  ellipsisButton: { background:'transparent', border:0, color:'#fff', fontSize:24, cursor:'pointer', padding:0 },

  /* ───── action buttons ───── */
  buttonRow: {
    display: 'flex',
    gap: 8,
    padding: '1px 16px',
    marginTop: 4,
  },
  buyNowButton: {
    flex: 1,
    alignSelf: 'center',
    justifyContent: 'center',
    padding: '10px 0',
    background: '#120F23',
    border: '2px solid rgba(98,251,250,0.5)',
    borderRadius: 6,
    color:'#fff',
    fontFamily:'brhendrix',
    fontSize: 15,
    cursor: 'pointer',
  },

  /* ───── creator / details ───── */
  creatorSection:   { padding: '0 16px', marginTop: 20 },
  creatorContainer: { display:'flex', alignItems:'center', cursor:'pointer' },
  creatorImage:     { width:50, height:50, borderRadius:'50%', objectFit:'cover', marginRight:10 },
  creatorUsername:  { color:'#fff', fontFamily:'brhendrix', fontSize:16 },

  details:    { padding:'0 16px', marginTop: 12 },
  detailItem: { color:'#fff', fontFamily:'brhendrix', fontSize:16, margin:'4px 0' },

  /* ───── song credits ───── */
  songCreditsSection: { padding:'0 16px', marginTop: 24 },
  creditSectionRow:   { display:'flex', gap: 24 },
  creditColumn:       { flex:1 },
  creditCategory:     { marginBottom: 16 },
  creditCategoryTitle:{ color:'#fff', fontFamily:'brhendrix', fontSize:16, marginBottom: 8 },
  creditText:         { color:'#fff', fontFamily:'brhendrix', fontSize:15 },
  linkText:           { color:'#62fbfa',     textDecoration: 'none', }, 

  /* ───── modals (unchanged) ───── */
/* ─────────── BUYDAT modal ─────────── */
modalOverlay: {
  position:   'fixed',
  inset:      0,
  background: 'rgba(0,0,0,0.65)',
  display:    'flex',
  /* make it slide-up from the bottom like iOS */
  justifyContent: 'center',
  alignSelf: 'center',
  alignItems:     'center',
  zIndex: 30,
  paddingTop: '60px',
},
modalContent: {
  width: '100%',
  maxWidth: 480,
  maxHeight: '90vh',
  background: '#0e061e',
  borderTopLeftRadius: 20,
  borderTopRightRadius: 20,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  position: 'relative',   // enables z-index inside
},


editionsList: {
  flex: 1,
  overflowY: 'auto',
  overscrollBehavior: 'contain',

  /* extra breathing-room so the first row can clear the app-bar */
  paddingTop: 80,            // ≈ height of your nav / status bar
  /* keep the close button clear of the bottom fade */
  paddingBottom: 3,
},



editionItem: {
  display:       'flex',
  flexDirection: 'row',
  alignItems:    'center',
  padding:       '5.5px 18px',
  borderBottom:  '1px solid rgba(255,255,255,0.2)',
},

bulletPoint: {
  fontSize: 14,
  color:    '#c8c8c8',
  marginRight: 12,
  flexShrink: 0,
},

editionRow: {
  flex: 1,
  display:        'flex',
  alignItems:     'center',
  justifyContent: 'space-between',
  gap: 16,
},

editionLeftText: {
  color:     '#fff',
  fontFamily:'brhendrix',
  fontSize:  16,
  flex:      1.2,
},

priceText: {
  fontFamily:'brhendrix',
  fontSize:  16,
  flex:      1,
  textAlign: 'left',
},

editionRightText: {
  fontFamily:'brhendrix',
  fontSize:  16,
  flex:      0.8,
  textAlign: 'right',
},

/* big Aqua “Close” button at the bottom */
closeModalButton: {
  width: '92%',
  margin: '0 auto 90px',
  padding: '14px 0',
  background: '#62fbfa',
  border: 0,
  borderRadius: 8,
  fontFamily: 'brhendrix',
  fontSize: 18,
  fontWeight: 'bold',
  cursor: 'pointer',

  position: 'sticky',   // stays visible at the bottom edge
  bottom: 0,
  zIndex: 5,            // overrides any fades/overlays
},

closeModalButtonText: {
  color: '#000',
  alignSelf: 'center',
},


  

  /* background flourish */
  popupImage: {
    position:'absolute',
    inset:0,
    width:'100%',
    height:'100%',
    zIndex:0,                       // ⇐ sits *behind* content now
    pointerEvents:'none',
  },


  modalOverlay2: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',  // ← center children horizontally
    alignItems: 'flex-end',    // ← pin children to bottom
    background: 'rgba(0,0,0,0.65)',
    zIndex: 30,
    paddingBottom: '20px',     // optional bottom gutter
  },
  

  /* ───── holders modal content ───── */
  modalContent2: {
    width: '475px',
    maxHeight: '85%',             // limit height, scroll inside if needed
    background: 'rgba(20,9,41,1)', // same as RN background
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    overflowY: 'auto',
    padding: '20px 20px 30px',     // give room for close button
  },

  /* ───── holder row ───── */
  holderRow2: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '5px 0',
    borderBottom: '1px solid #333',
  },

  /* ───── holder info (image + name) ───── */
  holderInfo2: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
  },

  /* ───── the little avatar ───── */
  creatorImage2: {
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '2px solid #62fbfa',   // aqua border
  },

  /* ───── holder’s username ───── */
  creatorUsername2: {
    color: '#fff',
    fontFamily: 'brhendrix',
    fontSize: '16px',
  },

  /* ───── edition “#3” text ───── */
  holderEditionText2: {
    color: '#fff',
    fontFamily: 'brhendrix',
    fontSize: '15px',
    textAlign: 'right',
    marginLeft: '12px',
    flexShrink: 0,
  },

  /* ───── empty state ───── */
  emptyText2: {
    color: '#fff',
    fontFamily: 'brhendrix',
    fontSize: '16px',
    textAlign: 'center',
    padding: '20px 0',
  },

  /* ───── close button (reuses your existing) ───── */
  closeModalButton2: {
    margin: '18px auto 6px',
    width: '92%',
    padding: '14px 0',
    background: '#62fbfa',
    border: 0,
    borderRadius: 8,
    cursor: 'pointer',
    fontFamily: 'brhendrix',
    fontSize: 18,
    fontWeight: 'bold',
    display: 'block',
  },



  modalContent2: {
    width: '475px',
    height: '90%',            
    background: 'rgba(20,9,41,1)',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    display: 'flex',           // ← make it a flex column
    flexDirection: 'column',
    overflow: 'hidden',        // we’ll scroll the inner list instead
    padding: '0',              // remove bottom padding
  },

  holdersList: {
    flex: 1,                   // ← take all remaining height
    overflowY: 'auto',
    padding: '20px',           // optional inner padding
  },

  emptyText2: {
    color: '#fff',
    fontFamily: 'brhendrix',
    fontSize: '16px',
    textAlign: 'center',
    marginTop: '20px',
  },

  holderRow2: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '5px 20px',
    borderBottom: '1px solid #333',
  },

  /* your existing holderInfo2, creatorImage2, etc. */

  closeModalButton2: {
    width: '100%',             // span full modal width
    padding: '14px 0',
    background: '#62fbfa',
    border: 'none',
    marginBottom: '35px',
    fontFamily: 'brhendrix',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },

  modalOverlay2: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    background: 'rgba(0,0,0,0.65)',
    paddingBottom: '20px',
    zIndex: 30,
  },



  // ───── More Info Modal ─────
modalOverlayInfo: {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0, 0, 0, 0.5)',   // semi-transparent
  display: 'flex',
  justifyContent: 'center',          // center vertically
  alignItems: 'center',              // center horizontally
  zIndex: 30,
},

modalOptionsContainerInfo: {
  width: '50%',                       // half the viewport width
  maxWidth: 400,                      // optional cap
  background: '#121523',              // same dark RN background
  borderRadius: 10,
  padding: 20,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
},

optionButtonInfo: {
  width: '100%',
  padding: '15px 0',
  borderBottom: '1px solid #62fbfa',
  background: 'transparent',
  cursor: 'pointer',
},

optionTextInfo: {
  color: '#fff',
  fontFamily: 'brhendrix',
  fontSize: '16px',                   // pick a comfortable size
  textAlign: 'center',
},

closeButtonInfo: {
  marginTop: 10,
  width: '50%',
  padding: 10,
  borderRadius: 5,
  background: 'transparent',
  cursor: 'pointer',
},

closeButtonTextInfo: {
  color: '#62fbfa',
  fontFamily: 'brhendrix',
  fontSize: '16px',
  fontWeight: 'bold',
  textAlign: 'center',
},
// ───── Post-Screen-Share Close Button ─────
closeButtonPost: {
  display: 'block',        // make it a block so margins work
  width: '50%',            // or whatever width you want
  margin: '10px auto 0',   // top-10px, left/right auto, bottom-0
  padding: '10px 0',
  borderRadius: 5,
  background: 'transparent',
  cursor: 'pointer',
},


closeButtonTextPost: {
  color: '#62fbfa',
  fontFamily: 'brhendrix',
  fontSize: '16px',
  fontWeight: 'bold',
  textAlign: 'center',
},



closeWrapper: {
  marginTop: '20px',
  display: 'flex',
  justifyContent: 'center',
  
},
closeButtonMessage: {
  width: '50%',
  padding: '10px 0',
  borderRadius: 5,
  background: 'transparent',
  cursor: 'pointer',
  display: 'block',
  margin: '0 auto',
  zIndex: 50,
  marginTop: '130px'
},
closeButtonTextMessage: {
  color: '#62fbfa',
  fontFamily: 'brhendrix',
  fontSize: '16px',
  fontWeight: 'bold',
  textAlign: 'center',
},

modalTitle: {
  color: '#fff',
  fontFamily: 'brhendrix',
  fontSize: 18,
  textAlign: 'center',
},
modalText: {
  color: '#fff',
  fontFamily: 'brhendrix',
  fontSize: 16,
  textAlign: 'center',
  marginBottom: 24,
  lineHeight: '22px',
},
modalButtons: {
  display: 'flex',
  gap: 16,
  width: '100%',
  justifyContent: 'center',
  
},
modalButton: {
  flex: 1,
  padding: '12px 0',
  background: '#62fbfa',
  border: 'none',
  borderRadius: 6,
  cursor: 'pointer',
  
},
modalButtonText: {
  color: '#000',
  fontFamily: 'brhendrix',
  fontSize: 16,
  fontWeight: 'bold',
},

// REPLACE/ADD: Song Credits styling to match RN layout
songCreditsSection: {
  padding: '0 16px',
  marginTop: 24,
},

// New grid/card layout (RN parity)
creditGrid: {
  width: '100%',
},
creditRow: {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',          // equal height cards in a row
  marginBottom: 12,
  gap: 10,
},
creditCard: {
  flexBasis: '50%',           // always take half the row
  maxWidth: '50%',            // prevent stretching
  background: '#120f23',
  borderRadius: 12,
  border: '1px solid rgba(98,251,250,0.35)',
  display: 'flex',
},
creditCardPlaceholder: {
  flexBasis: '50%',
  maxWidth: '50%',
  opacity: 0,                 // invisible but still occupies half-width
},

creditCardInner: {
  padding: '14px 12px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
},

creditCategoryTitleCentered: {
  color: '#62fbfa',
  fontFamily: 'brhendrix',
  fontWeight: 800,
  letterSpacing: 0.3,
  margin: 0,
  marginBottom: 8,
  fontSize: 18,
  textAlign: 'center',
},

creditList: {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  flexDirection: 'column',
},
creditTextRow: {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
},
creditTextCentered: {
  color: '#fff',
  fontFamily: 'brhendrix',
  fontSize: 15,
  textAlign: 'center',
  margin: 0,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%',
},
creditLink: {
  color: '#62fbfa',
  textDecoration: 'none',
  textShadow: '0 0 4px rgba(98,251,250,0.2)',
},

creditTextRow: {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
},

// add this:
ellipsisBlock: {
  display: 'block',
  width: '100%',
  maxWidth: '95%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: 'center',
},

// optional but helps keep rounded corners tidy if long text tries to overflow
creditCard: {
  flexBasis: '50%',
  maxWidth: '50%',
  background: '#120f23',
  borderRadius: 12,
  border: '1px solid rgba(98,251,250,0.35)',
  display: 'flex',
  overflow: 'hidden',     // <— add this
},

creditCard: {
  flexBasis: '50%',
  maxWidth: '50%',
  background: '#120f23',
  borderRadius: 12,
  border: '1px solid rgba(98,251,250,0.35)',
  display: 'flex',
  overflow: 'hidden',        // keep content clipped
},

creditCardInner: {
  padding: '14px 12px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',     // let children take full width
  minWidth: 0,               // REQUIRED for ellipsis inside flex
},

creditCategoryTitleCentered: {
  color: '#62fbfa',
  fontFamily: 'brhendrix',
  fontWeight: 800,
  letterSpacing: 0.3,
  margin: 0,
  marginBottom: 8,
  fontSize: 18,
  textAlign: 'center',
  width: '100%',             // ensure true centering
},

creditList: {
  width: '100%',
  display: 'flex',
  alignItems: 'stretch',     // rows fill width
  gap: 6,
  flexDirection: 'column',
  minWidth: 0,               // allow ellipsis further down
},

creditTextRow: {
  width: '100%',
  display: 'block',          // simpler for single child
  minWidth: 0,
  overflow: 'hidden',        // parent also hides overflow
},

ellipsisBlock: {
  display: 'block',
  width: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: 'center',
},

creditCardInner: {
  padding: '14px 12px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',   // center children horizontally
  width: '100%',
  minWidth: 0,            // required for ellipsis inside flex
},

creditCategoryTitleCentered: {
  color: '#62fbfa',
  fontFamily: 'brhendrix',
  fontWeight: 800,
  letterSpacing: 0.3,
  margin: 0,
  marginBottom: 8,
  fontSize: 18,
  width: '100%',          // make the title span the card
  textAlign: 'center',    // center the heading text
},

creditList: {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  alignItems: 'center',   // center single-item lists like Genres
  minWidth: 0,
},

creditTextRow: {
  width: '100%',
  display: 'flex',
  justifyContent: 'center', // center the row content
  minWidth: 0,
  overflow: 'hidden',
},

creditTextCentered: {
  color: '#fff',
  fontFamily: 'brhendrix',
  fontSize: 15,
  margin: 0,
  width: '100%',            // take full row width
  textAlign: 'center',      // center “Rap”
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis', // keep ellipsis for long labels
},




};

